import React from "react";
import classNames from "classnames/bind";
import { Button, Space, Row } from "@masterteam/mt-design-react";

import { ReactComponent as StrategicIcon } from "../../../assets/images/strategic-strategy.svg";
import { ReactComponent as SupportiveIcon } from "../../../assets/images/supportive-strategy.svg";

import styles from "./Item.module.scss";

const cx = classNames.bind(styles);

const Item = ({
  item,
  nameKey,
  isSelected = false,
  onClick,
  actions,
  showHideBox,
  color,
  children,
  isLast,
  showStrategyIcon,
}) => {
  return (
    <Row
      align="center"
      size="small"
      justify="between"
      className={cx({
        item: true,
        isSelected,
        pointer: onClick,
      })}
      onClick={onClick}
    >
      <Space align="center">
        {children}
        {showHideBox ? (
          <div
            style={{
              backgroundColor: color,
            }}
            className="dot_theme"
          />
        ) : null}
        {showStrategyIcon ? (
          +item.StrategyType === 1 ? (
            <StrategicIcon
              width={22}
              height={22}
              fill={isSelected ? "white" : "var(--primary-color)"}
            />
          ) : (
            <SupportiveIcon
              width={22}
              height={22}
              fill={isSelected ? "white" : "var(--primary-color)"}
            />
          )
        ) : null}
        <span className={styles.title}>{item[nameKey]}</span>
      </Space>
      {actions?.length ? (
        <Space align="center" onClick={(e) => e.stopPropagation()}>
          {actions.map((action) => {
            if (typeof action === "function") return action(item);
            return (
              <Button
                shape="square"
                fill="none"
                variant="dark"
                {...action}
                tooltip-position={isLast ? "top" : "buttom"}
                disabled={action.disabled?.(item)}
                onClick={() => action.onClick(item)}
                color={isSelected ? "#fff" : undefined}
              >
                {action.label}
              </Button>
            );
          })}
        </Space>
      ) : null}
    </Row>
  );
};

export default Item;
